module.exports = __webpack_public_path__ + "static/logo-e8f6f90da94879a0e1ffb65e8f2900f1.jpg";